
class Anchor {
  constructor() {
    $(document).on('click', 'a.disabled, a[disabled]', (e) => e.preventDefault());
  }
}

export default new Anchor();
